{% block swag_cms_extensions_form_template_modal %}
    <div class="swag-cms-extensions-form-template-modal">
        <mt-modal-root
            :is-open="displayModal"
            @change="onModalClose"
        >
            {% block swag_cms_extensions_form_template_modal_modal %}
                <mt-modal
                    class="swag-cms-extensions-form-template-modal__modal"
                    width="l"
                    :title="$tc('swag-cms-extensions.sw-cms.elements.custom-form.config.editFormTemplateLink')"
                >
                    {% block swag_cms_extensions_form_template_modal_modal_content %}
                        <div class="swag-cms-extensions-form-template-modal__content">
                            {% block swag_cms_extensions_form_template_modal_modal_content_search %}
                                {% block swag_cms_extensions_form_template_modal_modal_content_search_label %}
                                    {% block swag_cms_extensions_form_template_modal_modal_content_search_field %}
                                        <sw-simple-search-field
                                            v-model:value="searchTerm"
                                            class="swag-cms-extensions-form-template-modal__search-field"
                                            variant="form"
                                            :delay="750"
                                        ></sw-simple-search-field>
                                    {% endblock %}
                                {% endblock %}
                            {% endblock %}

                            <div class="swag-cms-extensions-form-template-modal__container">
                                {% block swag_cms_extensions_form_template_modal_modal_content_listing %}
                                    <sw-entity-listing
                                        v-if="total"
                                        ref="templateEntityListing"
                                        class="swag-cms-extensions-form-template-modal__entity-listing"
                                        :isLoading="isLoading"
                                        :items="formTemplates"
                                        :skeletonItemAmount="5"
                                        :steps="[5, 10]"
                                        :columns="columns"
                                        :repository="formTemplateRepository"
                                        :sortBy="sortBy"
                                        :sortDirection="sortDirection"
                                        :showSelection="false"
                                        :showSettings="false"
                                        :allowColumnEdit="false"
                                        :compactMode="false"
                                        :showActions="true"
                                        :fullPage="false"
                                        plainAppearance
                                        :allowInlineEdit="true"
                                        @inline-edit-save="onInlineEditSave"
                                        @column-sort="onSortColumn"
                                        @page-change="onPageChange"
                                        @delete-item-finish="getList"
                                    >
                                        {% block swag_cms_extensions_form_template_modal_modal_content_listing_more_actions %}
                                            <template #more-actions="{ item }">
                                                {% block swag_cms_extensions_form_template_modal_modal_content_listing_more_actions_rename %}
                                                    <sw-context-menu-item @click="onRename(item)">
                                                        {{ $tc('swag-cms-extensions.sw-cms.elements.custom-form.templateListing.renameContextAction') }}
                                                    </sw-context-menu-item>
                                                {% endblock %}
                                            </template>
                                        {% endblock %}
                                    </sw-entity-listing>
                                {% endblock %}

                                {% block swag_cms_extensions_form_template_modal_modal_content_empty_state %}
                                    <div
                                        v-else-if="!isLoading"
                                        class="swag-cms-extensions-form-template-modal__empty-state"
                                    >
                                        <img
                                            class="swag-cms-extensions-form-editor-empty-state__icon"
                                            :src="assetFilter('/swagcmsextensions/administration/static/img/shopping-experiences-empty-state.svg')"
                                        >

                                        <p>{{ $tc('swag-cms-extensions.sw-cms.elements.custom-form.templateListing.emptyState') }}</p>
                                    </div>
                                {% endblock %}
                            </div>
                        </div>
                    {% endblock %}

                    {% block swag_cms_extensions_form_template_modal_modal_footer %}
                        <template #footer>
                            <div class="swag-cms-extensions-form-template-modal__footer">
                                {% block swag_cms_extensions_form_template_modal_modal_footer_close_button %}
                                    <mt-button
                                        variant="secondary"
                                        @click="onModalClose"
                                    >
                                        {{ $tc('global.default.close') }}
                                    </mt-button>
                                {% endblock %}
                            </div>
                        </template>
                    {% endblock %}
                </mt-modal>
            {% endblock %}
        </mt-modal-root>
    </div>
{% endblock %}
